import { useEffect } from "react"
import { useLocation } from "react-router-dom"

import {
  PageComponentProps,
  isInPlaceEditingActive,
  provideComponent
} from "scrivito"
import {
  getBaseProduct,
  loadProductsForType
} from "shared/lib/product-obj/loadProduct"
import { NoComponentPage } from "shared/ui/no-component-page/NoComponentPage"

import { combineVariantKeys } from "entities/products/lib/combineVariantKeys"
import { getProductType } from "entities/products/lib/getProductType"
import { useNavigateToProduct } from "entities/products/model/useNavigateToProduct"
import { ProductPageConnector } from "pages/product-page/ProductPageConnector"

import {
  ProductBaseVariantAttributes,
  ProductBaseVariantObjClass
} from "./ProductBaseVariantObjClass"

provideComponent(ProductBaseVariantObjClass, props =>
  isInPlaceEditingActive() ? (
    <NoComponentPage />
  ) : (
    <ProductPageComponent {...props} />
  )
)

function ProductPageComponent({
  page
}: PageComponentProps<ProductBaseVariantAttributes>) {
  const variantKey = page.get("variantKey") || ""
  const standardConfiguration =
    (page.parent()?.get("standardConfiguration") as string) || ""
  const productType = (page.parent()?.get("productType") as string) || ""
  const { pathname } = useLocation()
  const navigate = useNavigateToProduct(null)

  useEffect(() => {
    const presetProductType = getProductType(variantKey)
    const parentProductType = getProductType(standardConfiguration)

    if (presetProductType !== parentProductType) {
      loadProductsForType(presetProductType).then(products => {
        const base = getBaseProduct(products)
        const combinedKey = combineVariantKeys(
          base?.get("standardConfiguration") || "",
          variantKey
        )
        if (combinedKey) {
          navigate({ variantKey: combinedKey })
        } else if (productType) {
          navigate({ variantKey: productType })
        }
      })
    }
  }, [pathname, variantKey, standardConfiguration])

  const combinedVariantKey = combineVariantKeys(
    standardConfiguration,
    variantKey
  )

  if (!combinedVariantKey) {
    return null
  }

  return <ProductPageConnector productType={productType} key={productType} />
}
